export default __webpack_public_path__ + "static/media/ldo_FIX_BIAS_nEN.ecb741b2.svg";